<template>
  <div id="alignment" v-loading="alignmentLoading" :element-loading-text="loadingText">
    <div class="alignment_title">
      <span></span>
      双语对齐
    </div>
    <div class="alignment_content">
      <div class="upload_wrap">
        <div class="language">
          <div class="language_left">
            <el-select @change="getLangeObjectLeft(sourceLeft)" v-model="sourceLeft" placeholder="源语言">
              <el-option v-for="(item, index) in LangList" :key="index" :label="item.sourceLangName"
                :value="item.sourceLang" :disabled="item.status == 0 || item.sourceLangName === sourceRight ">
              </el-option>
            </el-select>
            <i class="icon_right"></i>
            <!-- 目标语言 -->
            <el-select @change="getLangeObjectRight(sourceRight)" no-data-text="请先选择源语言" v-model="sourceRight"
              placeholder="目标语言">
              <el-option v-for="(item, index) in LangList2" :key="index" :label="item.targetLangName"
                :value="item.targetLang" :disabled="item.status == 0">
              </el-option>
            </el-select>
            <el-button @click="goAlignment">开始对齐</el-button>
          </div>
          <div class="language_right">
            <el-button :disabled="!userLastBatchID" @click="goDetails">最近对齐结果</el-button>
          </div>
        </div>
        <el-upload drag action :http-request="uploadSectionFile" :before-upload="beforeUploadFile"
          :on-change="uploadChange" multiple :limit="50" :on-exceed="handleExceed" list-type="text"
          :show-file-list="false" :file-list="fileArr" accept=".docx,.doc,.txt,.pdf,.xlsx,.xls,.pptx,.ppt,">
          <ul class="newproject-table" :style="fileArr.length ? '' : 'visibility: hidden;'">
            <li style="flexGrow:1">序号</li>
            <li style="flexGrow:6;textAlign:left">文档名称</li>
            <li style="flexGrow:1">进度</li>
            <li style="flexGrow:1"></li>
            <!-- <li style="flexGrow:1">源语言</li> -->
            <li style="flexGrow:1">删除</li>
          </ul>
          <ul class="newproject-array" v-if="fileArr.length ? true : false">
            <li v-for="(item, index) in fileArr" :key="index">
              <span style="width:10%">{{ index + 1 }}</span>
              <span style="width:60%;textAlign:left">
                <img :src=item.imgSrc alt="" style="marginRight:5px;">
                <!-- <svg-icon :icon-class="item.icon"></svg-icon> -->
                {{ item.name }}
              </span>
              <span style="width:9%" class="progress">
                <el-progress :show-text="false" :stroke-width="8" :status="item.exception"
                  :percentage="isNaN(item.percentage) ? 100 : item.percentage" class="progress"></el-progress>
                <p>{{ item.percentage + (isNaN(item.percentage) ? "" : "%") }}</p>
              </span>
              <span style="width:9.5%"></span>

              <!-- <span style="width:10%;color:#999999;">{{ item.source }}</span> -->
              <!-- <span style="width:10%">英文</span> -->
              <span style="width:10%">
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <img src="../../assets/imgs/memory/normal_delete.icon.png" @click.stop="handleDelete(index)"
                    style="cursor:pointer;marginLeft:25px;fontSize:20px" alt="">

                </el-tooltip>
              </span>
            </li>
          </ul>
          <div class="bot_box" v-if="fileArr.length ? true : false">
            <span style="float:left;margin:20px;">*点击或拖拽上传</span>
            <el-tooltip class="item" effect="dark" content="全部清空" placement="bottom-start">
              <i class="dele_all" @click.stop="messageIf"></i>
            </el-tooltip>
            <!-- <button  style="float:right;margin:20px;" >全部清空</button> -->
          </div>
          <div class="newproject-upload" v-if="fileArr.length ? false : true">
            <div class="uploadBox">
              <img src="../../assets/imgs/project/normal_upload.png" alt />
              <div class="el-upload__text">
                拖拽或点击上传，支持单个或双文件对照的 docx、doc、txt、pdf、xlsx、xls、pptx、ppt、格式文件，
                <em style="display:block;color:#606266;">单个文件20M以下</em>
              </div>
            </div>
          </div>

        </el-upload>
      </div>
      <messageBox v-if="mesBox" :isShow="mesBox" tit="友情提示" txt="确定清空文件吗？" @message="empty" @messageIf="messageIf">
      </messageBox>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import messageBox from "@/common/messageBox.vue";
export default {
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`

    clearTimeout(this.pollingInter);
    this.pollingInter = null;
    next()
  },
  name: "alignment",
  data () {
    return {
      sourceLanguage: "",
      targetLanguage: "",
      mesBox: false,
      sourceLeft: "",
      sourceRight: "",
      sourceLang: "",
      targetLang: "",
      LangList: [],
      LangList2: [],
      fileArr: [],
      filePathList: [],
      userLastBatchID: null,// 批次ID
      groupId: null,// 批次ID
      pollingInter: null,//定时器
      pollingNum: 0,// 轮询次数
      alignmentLoading: false,// loading 状态
      isMemory: null,// 是否添加过记忆库
      batchName: "", // 双语对齐文件名字
      fileStatus: null,//批次状态 -1.删除 0.禁用 1.启用
      prohibitClick: false,
      loadingText: "拼命加载中"
    }
  },
  components: {
    messageBox
  },
  created () {
    this.getLangList(1); // 获取源语言
    this.pollingAlignment()
  },
  methods: {
    // 开始双语对齐
    async goAlignment () {


      let that = this;
      // 禁止重复点击
      if (this.prohibitClick) {
        return
      }
      if (!that.sourceLang || !that.targetLang) {
        this.$message.closeAll();
        this.$message({
          message: "请选择语言!",
          type: "warning"
        });
        return;
      }
      if (that.sourceLang === that.targetLang) {
        this.$message.closeAll();
        this.$message({
          message: "源语言与目标语言不可一致！",
          type: "warning"
        });
        return;
      }
      let ary = [];
      let nameLen = true;
      if (that.fileArr.length) {
        // that.$store.state.fileList = that.fileArr;
        that.fileArr.forEach(item => {
          var re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
            resultArr = re.exec(item.name);
          var type = resultArr[2];
          if (resultArr[1].length > 80) {
            nameLen = false;
            return;
          }
          ary.push({
            fileName: item.name,
            filePath: item.path,
            fileSuffix: type,
            fileSize: item.size
          });
        });
        if (!nameLen) {
          this.$message.closeAll();
          this.$message({
            message: "文件名不得超过80个字符",
            type: "warning"
          });
          return;
        }
        if (!that.fileArr[0].path) {
          this.$message.closeAll();
          this.$message({
            message: "文件未上传完毕",
            type: "warning"
          });
          return;
        }
        let batchName = that.fileArr[0].name.split(".")[0]
        let params = {
          batchName,
          sourceLang: that.sourceLang,
          targetLang: that.targetLang,
          transFileList: ary
        }
        this.alignmentLoading = true // loading
        this.loadingText = `拼命加载中0%`
        this.prohibitClick = true // 禁止重复点击
        const res = await this.catReq1Service(`/api/v1/bilingual/save`, params)
        this.prohibitClick = false
        if (res.resultCode === "1") {
          this.groupId = res.result.groupId
          // 掉轮询接口查看对齐状态
          this.loadingText = `拼命加载中${res.result.percent}%`
          // this.userLastBatchID = res.result.id
          that.pollingAlignment()
        } else {
          this.alignmentLoading = false;
        }

      } else {
        this.$message.closeAll();
        this.$message({
          message: "请先上传文件",
          type: "warning"
        });
      }
    },
    //最近对齐结果，调整详情页面
    goDetails () {
      if (this.isMemory) {
        this.$message.closeAll();
        this.$message({
          message: '最近对齐结果已经保存到记忆库，到记忆库直接查看或编辑吧~',
          type: 'warning'
        });
        return
      }
      if (this.fileStatus === -1) {
        this.$message.closeAll();
        this.$message({
          message: '最近对齐结果已经删除，请重新上传需要对齐的文件',
          type: 'warning'
        });
        return
      }
      let that = this
      this.$router.push({
        name: "alignmentDetails",
        query: {
          id: that.userLastBatchID,
          batchName: that.batchName,
          groupId: that.groupId,
        },
      })
    },

    //监测状态---双语对齐状态
    async pollingAlignment () {

      this.alignmentLoading = true
      let params = {
        id: this.groupId
      }
      const res = await this.catReq1Service(`/api/v1/bilingual/getUserLastBatch`, params)
      if (res.success) {
        if (res.result.id === null) {
          this.alignmentLoading = false
        } else {
          // 盘对双语对齐进度是否完成
          this.loadingText = `拼命加载中${res.result.percent}%`
          if (res.result.percent !== 100 || res.result.dealStatus !== 2) {
            this.pollingInter = window.setTimeout(this.pollingAlignment, 2500);
          } else {
            // pollingNum = 0 代表第一次轮询，
            this.userLastBatchID = res.result.id
            this.groupId = res.result.groupId
            this.batchName = res.result.batchName
            this.isMemory = res.result.isMemory
            this.fileStatus = res.result.status
            if (this.pollingNum !== 0) {
              this.alignmentLoading = false
              this.$router.push({
                name: "alignmentDetails",
                query: {
                  id: res.result.id,
                  batchName: res.result.batchName,
                  groupId: res.result.groupId,
                },
              })
              clearTimeout(this.pollingInter);
            } else {
              this.alignmentLoading = false
              clearTimeout(this.pollingInter);
            }
          }
          this.pollingNum++
        }

      }
    },
    // 获取语言对  源语言
    getLangList (type, params) {
      var that = this;
      let obj = {
        type: type,
        [type === 1 ? "targetLang" : "sourceLang"]: params || ""
      };
      for (let propName in obj) {
        if (obj[propName] === "") {
          delete obj[propName];
        }
      }
      this.catReq1Service(`/api/v1/bilingual/queryLangList`, obj).then(function (
        response
      ) {
        if (!response.success) {
          return;
        }
        if (type === 1) {
          that.LangList = response.result;
        } else {
          that.LangList2 = response.result;
        }
      });
    },
    //选择源语言值后转换为对象 --- 源语言
    getLangeObjectLeft (v) {
      let that = this
      this.LangList.forEach(item => {
        if (item.sourceLang == v) {
          that.getSourceLeft(item)
        }
      });
    },
    //选择源语言值后转换为对象 --- 目标语言
    getLangeObjectRight (v) {
      let that = this
      this.LangList2.forEach(item => {
        if (item.targetLang == v) {
          that.getSourceRight(item)
        }
      });
    },
    // 选择语言对 左
    getSourceLeft (item) {
      var that = this;
      that.sourceLeft = item.sourceLangName;
      that.sourceLang = item.sourceLang;
      this.getLangList(2, item.sourceLang); // 获取语言对  目标语言
      this.visibleLef = false;
      // that.sourceLang && that.targetLang ? that.getDomainList(that.sourceLang, that.targetLang) : null
    },
    // 选择语言对 右
    getSourceRight (item) {
      var that = this;
      that.sourceRight = item.targetLangName;
      that.targetLang = item.targetLang;
      this.visibleRig = false;
    },
    // 切换语言
    switchover () {
      let sourceLeft = this.sourceLeft;
      let sourceLang = this.sourceLang;
      let targetLang = this.targetLang;
      let sourceRight = this.sourceRight;
      if (!sourceLeft && !sourceLang && !targetLang && !sourceRight) {
        return
      }
      this.sourceLang = targetLang
      this.targetLang = sourceLang
      this.sourceLeft = sourceRight;
      this.sourceRight = sourceLeft;
      this.getLangList(2, this.sourceLang); // 获取语言对  目标语言
    },
    // 清空文件列表弹窗
    messageIf () {
      var that = this;
      if (that.mesBox) {
        that.mesBox = false;
      } else {
        that.mesBox = true;
      }
    },
    //  清除文件列表
    empty () {
      var that = this;
      that.mesBox = false;
      that.fileArr = [];
      that.LangList2 = [];
      that.domainList = [];
      that.filePathList = [];
      that.sourceLeft = "";
      that.sourceRight = "";
      that.sourceLang = "";
      that.targetLang = "";
    },
    // 上传函数——获取签名
    async uploadSectionFile (param) {
      if (param.file.obp) {
        return;
      }
      let that = this;
      let fileObj = param.file;
      let re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
        resultArr = re.exec(param.file.name);
      let type = resultArr[2];
      let code = localStorage.getItem("myCompanyCode");
      let params = { companyCode: code, fileType: "project" };
      let url = "/api/v1/bilingual/getUploadSign";
      const res = await this.catReq1Service(url, params)
      if (!res.success) {
        return;
      }
      let data = res.result;
      that.host = data.host;
      let key = data.keyPrefix + "." + type;
      delete data.keyPrefix;
      delete data.host;
      that.formData = new FormData();
      that.formData.append("key", key);
      Object.keys(data).forEach(function (key) {
        that.formData.append(key, data[key]);
      });
      that.formData.append("file", fileObj);
      that.getFileHost(param);

    },
    // 上传的第二个函数
    getFileHost (param) {
      let that = this;
      let FileController = that.host;
      let config = {
        onUploadProgress: progressEvent => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      };
      axios
        .post(FileController, that.formData, config)
        .then(function (response) {
          if (!response) {
            return;
          }
          that.filePathList.push(response.data.result);
          that.fileArr.forEach(item => {
            if (item.uid === param.file.uid) {
              item.path = response.data.result.fileName;
            }
          });
        })
        .catch(function (error) {
          that.fileArr.forEach(item => {
            if (item.name == param.file.name) {
              item.exception = "exception";
              item.percentage = "上传失败";
            }
          });
        });
    },
    //上传前的函数(用于验证上传文件格式及大小)
    beforeUploadFile (file) {
      let fileArr = file.name.split(".")
      // let reg = /(^\s+)|(\s+$)|\s+/g;
      // let reg1 = /[`~!@#$%^&*()_\-+=<>?:"{}|,\/;'\\[\]@#￥%&*（）——\-+={}]/im;
      var regEn = /[*<>|?:\/[\]]/im;
      let type = fileArr[fileArr.length - 1]; // 拿到文件后缀
      const isDOCX = type === "docx";
      const isDOC = type === "doc";
      const isTXT = type === "txt";
      const isPDF = type === "pdf";
      const isXLSX = type === "xlsx";
      const isXLS = type === "xls";
      const isPPTX = type === "pptx";
      const isPPT = type === "ppt";
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (regEn.test(file.name)) {
        this.$message.closeAll();
        this.$message({
          message: "暂不支持特殊符号!",
          type: "warning"
        });
        file.obp = true;
        return false;
      }

      if (
        !isDOCX &&
        !isDOC &&
        !isTXT &&
        !isPDF &&
        !isXLSX &&
        !isXLS &&
        !isPPTX &&
        !isPPT
      ) {
        // this.fileArr.pop();  、pdf、ppt、pptx
        this.$message.closeAll();
        this.$message({
          message: "只支持 doc、docx、txt、pdf、xlsx、xls、pptx、ppt格式!",
          type: "warning"
        });
        file.obp = true;
        return false;
      }

      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          message: "不支持上传空文件",
          type: "warning"
        });
        return false;
      }
      if (!isLt20M) {
        // this.fileArr.pop();
        this.$message.closeAll();
        this.$message({
          message: "上传文件大小不能超过 20MB!",
          type: "warning"
        });
        file.obp = true;
        return false;
      }
      this.fileArr.slice(0, -1).forEach(item => {
        if (item.name == file.name) {
          this.fileArr.pop();
          this.$message.closeAll();
          this.$message({
            message: "上传文件名称重复!",
            type: "warning"
          });
          file.obp = true;
          return false;
        }
      });

      return (isDOCX || isDOC || isTXT || isPDF || isPPT || isXLSX || isPPTX || isXLS) && isLt20M;
    },
    // 文件图标
    uploadChange (event, file, fileList) {
      this.fileArr = file;
      file.forEach(item => {
        if (item.raw) {
          switch (this.typeReg(item.name)) {
            case "pdf":
              item.imgSrc = require("../../assets/imgs/project/press_pdf.icon.png");
              this.qwer = "pdf";
              break;
            case "doc":
              item.imgSrc = require("../../assets/imgs/project/press_word.icon.png");
              this.qwer = "doc";
              break;
            case "docx":
              item.imgSrc = require("../../assets/imgs/project/press_word.icon.png");
              break;
            case "ppt":
              item.imgSrc = require("../../assets/imgs/project/press_ppt.icon.png");
              break;
            case "pptx":
              item.imgSrc = require("../../assets/imgs/project/press_ppt.icon.png");
              break;
            case "xls":
              item.imgSrc = require("../../assets/imgs/project/press_xlsx.icon.png");
              break;
            case "xlsx":
              item.imgSrc = require("../../assets/imgs/project/press_xlsx.icon.png");
              break;
            case "txt":
              item.imgSrc = require("../../assets/imgs/project/txt.png");
              break;
            case "html":
              item.imgSrc = require("../../assets/imgs/project/html.png");
            case "htm":
              item.imgSrc = require("../../assets/imgs/project/html.png");
            case "jpg":
              item.imgSrc = require("../../assets/imgs/project/tupian.png");
              break;
            case "png":
              item.imgSrc = require("../../assets/imgs/project/tupian.png");
              break;
            case "bmp":
              item.imgSrc = require("../../assets/imgs/project/tupian.png");
              break;
              break;
            default:
              break;
          }
        }
      });
    },
    // 文件个数超出限制
    handleExceed () {
      let mes = ''
      this.$privatization ? mes = "最多50个文件" : mes = "最多50个文件"
      this.$message.closeAll();
      this.$message({
        message: mes,
        type: "warning"
      });
    },
    // 删除文件
    handleDelete (index) {
      this.fileArr.splice(index, 1);
      this.filePathList.splice(index, 1);
    },
  },
  beforeDestroy () {
    clearTimeout(this.pollingInter);
    this.pollingInter = null;
  }
};
</script>
<style lang="less" >
#alignment {
  width: 100%;
  height: 100%;
  /*标题*/
  .alignment_title {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    span {
      width: 5px;
      height: 16px;
      background: #0290FD;
      margin-left: 35px;
      margin-right: 11px;
    }
  }
  /*内容部分样式*/
  .alignment_content {
    width: 100%;
    margin-top: 20px;
    height: calc(100% - 60px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    display: flex;
    justify-content: center;
    .upload_wrap {
      // width: 1230px;
      width: 70%;
      margin-top: 80px;
      /*内容部分上面部分*/
      .language {
        width: 100%;
        height: 36px;
        margin-bottom: 31px;
        display: flex;
        justify-content: space-between;
        /*下拉框分样式*/
        .el-select {
          width: 160px;
          .el-input {
            width: 100%;
          }
        }
        /*内容部分上面部分左边*/
        .language_left {
          display: flex;
          justify-content: center;
          .icon_right {
            display: inline-block;
            width: 32px;
            height: 32px;
            text-align: center;
            cursor: pointer;
            margin: 0 20px;
            background: url("../../assets/imgs/memory/youxiang_jt.png")
              no-repeat;
            background-position: center;
          }
          .el-button {
            background: #5256E9;
            border-radius: 4px;
            color: #ffffff;
            margin-left: 30px;
            line-height: 0;
          }
        }
        /*内容部分上面部分右边*/
        .language_right {
          .el-button {
            font-size: 14px;
            background: #767AF5;
            border-radius: 4px;
            height: 36px;
            width: 110px;
            padding: 0;
            line-height: 0;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
      /*上传文件*/
      .el-upload {
        width: 100%;
        height: 400px;
        margin: 0 auto;
        .newproject-upload {
          height: 100%;
          position: relative;
          top: 20%;
          .uploadBox {
            img {
              margin-bottom: 34px;
            }
          }
        }
        .el-upload-dragger {
          position: relative;
          width: 100%;
          height: 400px;
          background: #f1f1f1;

          .newproject-table {
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(69, 69, 69, 1);
            position: relative;
            top: 0;
            display: flex;
          }
          .newproject-array {
            height: 272px;
            overflow-y: auto;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            li {
              display: flex;
              margin: 5px 0;
              height: 40px;
              border-bottom: 1px solid rgba(226, 225, 225, 1);
              line-height: 40px;
              span {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
            li:hover {
              background: #dbe3e7;
            }
          }
          .bot_box {
            width: 100%;
            position: absolute;
            bottom: 0;
            button {
              z-index: 999999999;
              width: 8%;
              height: 30px;
            }
            .dele_all {
              vertical-align: middle;
              width: 16px;
              height: 16px;
              float: right;
              margin-right: 60px;
              margin-top: 11px;
              cursor: pointer;
              background: url("../../assets/imgs/project/qb_delet_normal.png")
                center no-repeat;
            }
            .dele_all:hover {
              background: url("../../assets/imgs/project/qb_delet_press.png")
                center no-repeat;
            }
            span {
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(128, 128, 128, 1);
            }
          }
        }
      }
    }
  }
}
</style>
